import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=179b7153&scoped=true&"
import script from "./index2.vue?vue&type=script&lang=js&"
export * from "./index2.vue?vue&type=script&lang=js&"
import style0 from "./index2.vue?vue&type=style&index=0&id=179b7153&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b7153",
  null
  
)

export default component.exports